<main class="display-block minh-viewport width-full">
  <router-outlet></router-outlet>

</main>

<app-header></app-header>

<app-footer  ></app-footer>